import React from 'react';

import type { IntlShape } from 'react-intl-next';

import type { EditorView } from '@atlaskit/editor-prosemirror/view';
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import type { BaseAIAction } from '@atlassian/ai-smart-button-api';

import type { AIGlobalOptIn } from '../../../types/types';
import type { EditorPluginAIConfigItemWithOptions } from '../../../ui/prebuilt/config-items/config-items';
import { createOpenAIModalCommand } from '../../decoration/actions';

export const createGetNudgeFromConfigItem = ({
	editorView,
	configItem,
	aiGlobalOptIn,
	intl,
}: {
	editorView: EditorView;
	configItem: EditorPluginAIConfigItemWithOptions;
	intl: IntlShape;
	aiGlobalOptIn: AIGlobalOptIn;
}): ((nudgeMetrics?: Record<string, number | undefined>) => BaseAIAction) => {
	return (nudgeMetrics?: Record<string, number | undefined>) => ({
		id: configItem.config.key,
		title: intl.formatMessage(configItem.config.title),
		description: intl.formatMessage(configItem.config.description),
		icon: configItem.config.icon?.({ formatMessage: intl.formatMessage }) || (
			<AtlassianIntelligenceIcon label="" spacing="spacious" />
		),
		onClick: () => {
			editorView.focus();
			createOpenAIModalCommand({
				state: editorView.state,
				configItem: configItem.config,
				lastTriggeredFrom: 'rovoButtonNudge',
				nudgeMetrics,
				aiGlobalOptIn,
			})(editorView.state, editorView.dispatch);
		},
	});
};
